import { NotificationId } from 'features/notifications/types';
import { call, put } from 'redux-saga/effects';
import { Action } from '@reduxjs/toolkit';
import { closeActionNotification } from 'features/notifications/thunks/closeActionNotification';

export function* closeQuizTakeRequestNotificationSaga(id: NotificationId) {
  const cleanupNotificationThunk: Action = yield call(
    closeActionNotification,
    `quiz_request_take_${id}`
  );
  yield put(cleanupNotificationThunk);
}
